export const formatNumericUserDate = (date: Date, locale: string[], includeWeekday = false): string =>
	new Intl.DateTimeFormat(locale, {
		day: 'numeric',
		month: 'numeric',
		year: 'numeric',
		weekday: includeWeekday ? 'long' : undefined,
	})
		.format(date)
		.replace(/ /g, '\xA0');
